module.exports = __webpack_public_path__ + "static/media/Dominic Filipponi_1621433828078.4a197633.jpeg";